import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "size-full flex flex-col" };
const _hoisted_2 = { class: "flex-shrink-0 pt-3 pb-1 bg-white" };
const _hoisted_3 = { class: "relative" };
const _hoisted_4 = { class: "absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center gap-1" };
const _hoisted_5 = { class: "flex-1 overflow-y-auto scroll-smooth pb-4" };
const _hoisted_6 = {
    key: 0,
    class: "flex items-center justify-center py-8"
};
const _hoisted_7 = {
    key: 1,
    class: "flex items-center justify-center py-8"
};
const _hoisted_8 = {
    key: 2,
    class: "space-y-6"
};
const _hoisted_9 = { class: "sticky top-0 bg-neutral backdrop-blur-sm border-b border-line" };
const _hoisted_10 = { class: "text-2xl font-medium pl-3 text-badge" };
const _hoisted_11 = { class: "space-y-1" };
const _hoisted_12 = ["onClick"];
const _hoisted_13 = { class: "flex-1" };
const _hoisted_14 = { class: "text-badge font-medium" };
const _hoisted_15 = {
    key: 0,
    class: "w-3 h-3 text-white",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
};
const _hoisted_16 = {
    key: 0,
    class: "mt-6 p-4 bg-neutral/30 rounded-lg"
};
const _hoisted_17 = { class: "text-badge font-medium mb-2" };
const _hoisted_18 = { class: "flex flex-wrap gap-2" };
const _hoisted_19 = ["onClick"];
import { computed, ref } from 'vue';
import { X, Search } from 'lucide-vue-next';
import { useHomeFilterStore } from './homeFilterStore';
export default /*@__PURE__*/ _defineComponent({
    __name: 'home-filter-dialog-brand',
    setup(__props) {
        const homeFilterStore = useHomeFilterStore();
        const searchTerm = ref('');
        const selectedCount = computed(() => {
            return homeFilterStore.selectedBrands.length;
        });
        // Filter brands based on search term, then group by first letter
        const filteredGroupedBrands = computed(() => {
            // First filter brands by search term
            const filteredBrands = homeFilterStore.brands.filter(brand => brand.name.toLowerCase().includes(searchTerm.value.toLowerCase()));
            // Then group filtered brands by first letter
            const groups = {};
            filteredBrands.forEach(brand => {
                const firstLetter = brand.name.charAt(0).toUpperCase();
                if (!groups[firstLetter]) {
                    groups[firstLetter] = [];
                }
                groups[firstLetter].push(brand);
            });
            // Sort the groups by letter key
            const sortedGroups = {};
            Object.keys(groups)
                .sort()
                .forEach(key => {
                sortedGroups[key] = groups[key];
            });
            return sortedGroups;
        });
        const handleBrandToggle = (brandId) => {
            homeFilterStore.toggleBrandSelection(brandId);
        };
        const clearSearch = () => {
            searchTerm.value = '';
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchTerm).value = $event)),
                            type: "text",
                            placeholder: "Search brands...",
                            class: "w-full p-2 pr-20 border border-badge/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary2 focus:border-primary2 text-badge"
                        }, null, 512), [
                            [_vModelText, searchTerm.value]
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            (searchTerm.value)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: clearSearch,
                                    class: "p-1 hover:bg-badge/10 rounded-full transition-colors",
                                    title: "Clear search"
                                }, [
                                    _createVNode(_unref(X), { class: "size-4 text-badge/70 hover:text-badge" })
                                ]))
                                : _createCommentVNode("", true),
                            _createVNode(_unref(Search), { class: "size-4 text-badge/50" })
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                    (_unref(homeFilterStore).brands.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[1] || (_cache[1] = [
                                _createElementVNode("div", { class: "text-badge text-center" }, [
                                    _createElementVNode("div", { class: "text-lg font-medium mb-2" }, "No brands available"),
                                    _createElementVNode("div", { class: "text-sm opacity-70" }, "Brands will appear here when loaded")
                                ], -1)
                            ]))]))
                        : (filteredGroupedBrands.value && Object.keys(filteredGroupedBrands.value).length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[2] || (_cache[2] = [
                                    _createElementVNode("div", { class: "text-badge text-center" }, [
                                        _createElementVNode("div", { class: "text-lg font-medium mb-2" }, "No brands found"),
                                        _createElementVNode("div", { class: "text-sm opacity-70" }, "Try a different search term")
                                    ], -1)
                                ]))]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredGroupedBrands.value, (group, letter) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: letter,
                                        class: "space-y-2"
                                    }, [
                                        _createElementVNode("div", _hoisted_9, [
                                            _createElementVNode("h3", _hoisted_10, _toDisplayString(letter), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_11, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (brand) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: brand.id,
                                                    class: "border-b border-line flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-neutral/50 transition-colors cursor-pointer",
                                                    onClick: ($event) => (handleBrandToggle(brand.id))
                                                }, [
                                                    _createElementVNode("div", _hoisted_13, [
                                                        _createElementVNode("div", _hoisted_14, _toDisplayString(brand.name), 1)
                                                    ]),
                                                    _createElementVNode("div", {
                                                        class: _normalizeClass(["flex-shrink-0 w-5 h-5 border-2 rounded flex items-center justify-center transition-all", [
                                                                brand.isSelected
                                                                    ? 'bg-primary2 border-primary2'
                                                                    : 'border-badge bg-white hover:border-primary2'
                                                            ]])
                                                    }, [
                                                        (brand.isSelected)
                                                            ? (_openBlock(), _createElementBlock("svg", _hoisted_15, [...(_cache[3] || (_cache[3] = [
                                                                    _createElementVNode("path", {
                                                                        "stroke-linecap": "round",
                                                                        "stroke-linejoin": "round",
                                                                        "stroke-width": "3",
                                                                        d: "M5 13l4 4L19 7"
                                                                    }, null, -1)
                                                                ]))]))
                                                            : _createCommentVNode("", true)
                                                    ], 2)
                                                ], 8, _hoisted_12));
                                            }), 128))
                                        ])
                                    ]));
                                }), 128)),
                                (selectedCount.value > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        _createElementVNode("div", _hoisted_17, "Selected Brands (" + _toDisplayString(selectedCount.value) + ")", 1),
                                        _createElementVNode("div", _hoisted_18, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(homeFilterStore).selectedBrands, (selectedBrand) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: selectedBrand.id,
                                                    class: "inline-flex items-center gap-2 bg-primary2/10 text-primary2 px-3 py-1 rounded-full text-sm"
                                                }, [
                                                    _createElementVNode("span", null, _toDisplayString(selectedBrand.name), 1),
                                                    _createElementVNode("button", {
                                                        onClick: _withModifiers(($event) => (handleBrandToggle(selectedBrand.id)), ["stop"]),
                                                        class: "hover:bg-primary2/20 rounded-full p-0.5 transition-colors"
                                                    }, [
                                                        _createVNode(_unref(X), { class: "w-3 h-3" })
                                                    ], 8, _hoisted_19)
                                                ]));
                                            }), 128))
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]))
                ])
            ]));
        };
    }
});
